import React from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { Gear, SignOut } from '@phosphor-icons/react';
import { cn } from '@/lib/utils';

export default function UserMenu({
  sidebarCollapsed,
  initials,
  user,
  navigate,
  handleLogout,
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className={cn(
            'w-full flex items-center rounded-md hover:bg-muted transition-colors',
            sidebarCollapsed ? 'justify-center p-2' : 'gap-3 px-3 py-2',
          )}
          data-testid="user-menu-trigger"
        >
          <Avatar className="w-8 h-8 flex-shrink-0">
            <AvatarFallback className="bg-primary text-primary-foreground text-sm font-medium">
              {initials}
            </AvatarFallback>
          </Avatar>
          {!sidebarCollapsed && (
            <div className="flex-1 text-left min-w-0">
              <p className="text-sm font-medium truncate">{user?.name}</p>
              <p className="text-xs text-muted-foreground truncate">{user?.email}</p>
            </div>
          )}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align={sidebarCollapsed ? 'center' : 'end'} side={sidebarCollapsed ? 'right' : 'top'} className="w-56">
        <DropdownMenuItem onClick={() => navigate('/settings')} data-testid="menu-settings">
          <Gear size={16} className="mr-2" />
          Settings
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleLogout} className="text-destructive" data-testid="menu-logout">
          <SignOut size={16} className="mr-2" />
          Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
